import * as React from 'react';
import {

    List,
    Datagrid,
    TextField,
    NumberField,
    ImageField, EditButton,
    Filter,
    TextInput,
} from 'react-admin';
import FormattedDateTimeField from "../../common/FormattedDateTimeField";
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const PodcastTopicList = () => {
    const { isUpdatable, isWritable, isDeletable } = useIsPermission("PODCAST");
    return (
        <List
            filters={<ListFilter />}
            actions={<PermissionBasedActions isWritable={isWritable} />}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
            sort={{ field: 'display_order', order: 'ASC' }}>
            <Datagrid>
                <ImageField source={'thumbnail'} />
                <TextField source="name" sortable={false} />
                <NumberField source={'displayOrder'} sortable={false} />
                <FormattedDateTimeField source="createdAt" sortable={false} />
                {isUpdatable &&
                    <EditButton />
                }
                {isDeletable &&
                    <ConfirmDeleteButton />
                }
            </Datagrid>
        </List>
    );
};
export default PodcastTopicList;
